import {Nullable} from '../../../app/TypeHelpers'
import {PAYMENT_TYPE} from '../../../CodeMaster'
import {PaymentItemForView} from './PaymentItemForView'
import {COMMON_CONSTANTS} from '../../../CommonConstants'

export class PaymentItemForViewFacility extends PaymentItemForView {
    constructor(paymentType: PAYMENT_TYPE, charge: Nullable<number>) {
        super(null, '施設利用料', paymentType, charge, COMMON_CONSTANTS.DISPLAY_ORDER_FACILITY)
    }

    quantityWithUnit(): string {
        return COMMON_CONSTANTS.INVALID_CALCULATE_RESULT
    }
}
